import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useEffect } from 'react';

import { Box, Flex, Icon, Loader, Modal, Text } from '~/components/blocks';
import { ExternalLink } from '~/components/blocks/ExternalLink';
import { LineVisitorChargePanel } from '~/components/partials/LineVisitorChargePanel';
import { lineVisitorChargeModalState } from '~/state/reception/atoms';

import { useFetchAppointment } from './use-fetch-appointment';

export const LineVisitorChargeModal = () => {
  const state = useAtomValue(lineVisitorChargeModalState);
  const resetChargeModalState = useResetAtom(lineVisitorChargeModalState);

  const appointment = useFetchAppointment();

  useEffect(() => {
    if (!state.isOpen) {
      resetChargeModalState();
    }
  }, [resetChargeModalState, state.isOpen]);

  return (
    <Modal open={state.isOpen} size="s" onClose={resetChargeModalState}>
      <Modal.Header>
        <Flex alignItems="center">
          <Text>会計</Text>
          <Flex alignItems="center" justifyContent="flex-end" width="83%">
            <Icon icon="hint" size="l" color="grey" />
            <ExternalLink
              color="black"
              url="https://intercom.help/pharms/ja/articles/10115094-%E4%BC%9A%E8%A8%88%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E3%82%88%E3%81%8F%E3%81%82%E3%82%8B%E3%81%94%E8%B3%AA%E5%95%8F"
              fontSize="s"
            >
              会計で困ったときは
            </ExternalLink>
          </Flex>
        </Flex>
      </Modal.Header>
      {appointment ? (
        <LineVisitorChargePanel appointment={appointment} />
      ) : (
        <Modal.Body>
          <Box position="relative" height="240px">
            <Loader open inside />
          </Box>
        </Modal.Body>
      )}
    </Modal>
  );
};
